import React, { useState } from "react";
import add_icon from "./images/add_icon.png";
import minus_icon from "./images/minus_icon.png";
import "./index.scss";
const handleChildren = (data, dataSource) => {
  return data?.map((item) => {
    const typeVal = item?.ui?.type;
    const type =
      typeVal === "uploader"
        ? "img"
        : typeVal == "datePicker"
        ? "datePicker"
        : "text";
    if (item?.ui?.type === "object" && item?.schema?.length > 0) {
      return {
        label: item?.title,
        type: typeVal,
        value: dataSource?.[item?.fieldKey] || null,
        children: handleChildren(item?.schema, dataSource),
      };
    }
    return {
      label: item?.title,
      type: type,
      value: dataSource?.[item?.fieldKey] || null,
    };
  });
};
const handleH5data = (schema, formValues) => {
  const dataSource = {};
  for (const { key, value } of formValues || []) {
    dataSource[key] = value;
  }
  let list = schema?.map((item) => {
    console.log("itemitem", item);
    const typeVal = item?.ui?.type;
    let type;
    if (typeVal === "uploader") {
      type = "img";
    } else if (typeVal == "datePicker") {
      type = "datePicker";
    } else {
      type = "text";
    }
    console.log("dataSource", dataSource);
    if (item?.ui?.type === "object") {
      return {
        label: item?.title,
        type: item?.ui?.type,
        value: dataSource?.[item?.fieldKey] || null,
        children: handleChildren(item?.schema, dataSource),
      };
    }
    return {
      label: item?.title,
      type: type,
      value: dataSource?.[item?.fieldKey] || null,
    };
  });
  console.log("list", list);
  return list;
};
// 递归渲染树节点
function TreeNode({ data }) {
  const [isExpanded, setIsExpanded] = useState(true);
  const toggleExpand = () => {
    setIsExpanded(!isExpanded);
  };
  console.log("444444444", data);
  return (
    <div>
      <div
        onClick={toggleExpand}
        className="productDetail_menu_box"
        style={{ cursor: "pointer" }}
      >
        {data.type == "object" && data.children && data.children?.length > 0 && (
          <>
            {isExpanded ? (
              <img src={minus_icon} className="isExpanded_img" alt="" />
            ) : (
              <img className="isExpanded_img" src={add_icon} alt="" />
            )}
            <span style={{ marginLeft: "0.1rem" }}>{data.label}: </span>
          </>
        )}
        {data.type != "object" && data.value && <>{data.label}:</>}
      </div>
      {isExpanded &&
        data.type == "object" &&
        data.children &&
        data.children?.length > 0 && (
          <div style={{ marginLeft: ".53rem" }}>
            {data?.children?.map((child, index) => (
              <div key={index}>
                {child.type == "object" && <TreeNode data={child} />}
                {(child.type == "text" ||
                  child.type == "number" ||
                  child.type == "select") && (
                  <div className="tree_children_bg">
                    <p className="tree_children_title">{child.label}</p>
                    <p className="tree_children_value">{child.value}</p>
                  </div>
                )}
                {child.type == "img" && (
                  <div className="tree_children_bg">
                    <p className="tree_children_title">{child.label}</p>
                    {child?.value?.map((imgList) => {
                      return (
                        <img
                          className="tree_children_img"
                          alt=""
                          src={imgList}
                        />
                      );
                    })}
                  </div>
                )}
                {child.type == "datePicker" && (
                  <div className="tree_children_bg">
                    <p className="tree_children_title">{child.label}</p>
                    <p className="tree_children_value">
                      {Array.isArray(child.value)
                        ? child?.value?.[0] + " - " + child?.value?.[0]
                        : child?.value || ""}
                    </p>
                  </div>
                )}
              </div>
            ))}
          </div>
        )}
      {data.type != "object" && (
        <>
          {data.type == "img" && data?.value?.length > 0 && (
            <div className="tree_children_bg">
              {/* <p className="tree_children_title">{data.label}</p> */}
              {data?.value?.map((imgList) => {
                return (
                  <img className="tree_children_img" alt="" src={imgList} />
                );
              })}
            </div>
          )}
          {data.type == "datePicker" && data.value && (
            <div className="tree_children_bg">
              <p className="tree_children_title">{data.label}</p>
              <p className="tree_children_value">
                {Array.isArray(data.value)
                  ? data?.value?.[0] + " - " + data?.value?.[0]
                  : data?.value || ""}
              </p>
            </div>
          )}
          {(data.type == "text" ||
            data.type == "number" ||
            data.type == "select") &&
            data.value && (
              <div className="tree_children_bg">
                <p className="tree_children_title">{data.label}</p>
                <p className="tree_children_value">{data.value}</p>
              </div>
            )}
        </>
      )}
    </div>
  );
}

function ProductDetailsTree({ data }) {
  /* const newData = handleH5data(
    data?.formContext?.schema,
    data?.formValues?.data
  ); */
  console.log("1100000000", data);
  return (
    <div className="product_details_tree">
      {data?.map((node, index) => {
        return (
          <div key={index}>
            <TreeNode data={node} />
          </div>
        );
      })}
    </div>
  );
}

export default ProductDetailsTree;

export { ProductDetailsTree, handleH5data };
